module.exports = __webpack_public_path__ + "static/media/Yash Chandak.b9c1824a.jpg";